import { Component } from '@angular/core';
import {HostListener} from '@angular/core';


import {ReportDataService} from './report-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'FlexFile Ingestion';
  //TEMP for testing
  //isInit = false;
  isInit = true;
  errorCount = 0;

  constructor(private reportService: ReportDataService) {
    window.onbeforeunload = function(e) {
  //    e.returnValue='Please be sure to save your FlexFile before you head out.  If you don\'t, you\'ll lose all your progress';
      return 'Please be sure to save your FlexFile before you head out.  If you don\'t, you\'ll lose all your progress';
    }
    this.reportService.getInit().subscribe(value => this.isInit = value);
    this.reportService.getErrorCount().subscribe(value => this.errorCount = value);
  }

  /**
   * Handle the "Save File" button click event..delegate to Report Service
   * @param event the click event
   */
  save(event) {
    this.reportService.save();
  }

  sendLeavingWarning() {
    return 'Please be sure to save your FlexFile before you head out.  If you don\'t, you\'ll lose all your progress';
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts